import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Role } from '@classes/role';
import { Role as RoleEnum } from '@enums/role.enum';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/role';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getRoles(): Observable<Array<Role>> {
    return this.http.get<Array<Role>>(this.basePath);
  }

  getSelectableRoleByUserRole(role: RoleEnum | undefined): RoleEnum[] {
    switch (role) {
      case RoleEnum.administrator:
        return [RoleEnum.administrator, RoleEnum.manager, RoleEnum.user];
      case RoleEnum.manager:
        return [RoleEnum.manager, RoleEnum.user];
      case RoleEnum.user:
        return [RoleEnum.user];
    }
    return [];
  }

}
